<template>
  <div class="form-struct-control-content">
    <el-form :model="ruleForm" ref="form">
      <!-- 列结构 -->
      <el-row :gutter="20">
        <el-col :span="getSpan(item)" v-for="item in formatData" :key="item.id">
          <div class="form-field-wrap" v-if="item.value">
            <el-form-item v-if="showLogIcon(item)" :label="item.structName+'：'">
              <!-- <div class="data-log-icon-wrap" v-if="isEdit && showLogIcon(item)">
                <gov-field-log-popups
                  @revert="handleRevertField"
                  :household-id="householdId"
                  :struct-id="item.id"
                  :project-id="projectId"
                ></gov-field-log-popups>
              </div>-->
              <!-- <div class="w100" style="line-height:24px;" v-if="item.structType === 'm'">
                <span v-if="item.value.indexOf(',')===-1">{{item.value[0]}}</span>
                <span style="margin-left:10px" v-if="item.value.length>0">+{{item.value.length-1}}</span>
              </div> -->
              <div class="w100" style="line-height:23px;">{{item.value}}  {{item.unitName}}</div>
              <!-- <gov-measure-tool
                :unit-name="item.unitName"
                :unit-id="item.unitId"
                :dot="item.dot"
                :disabled="!isEdit || item.isRead === 1"
                v-model="item.value"
                :label="item.structName"
                v-if="item.structType === 'di'"
              ></gov-measure-tool>-->
              <!-- <el-input
                size="small"
                v-if="item.structType === 't'"
                :disabled="!isEdit || item.isRead === 1"
                v-model="item.value"
                class="w100"
              ></el-input>-->
              <!-- <el-input
                size="small"
                v-if="item.structType === 't'"
                :disabled="!isEdit || item.isRead === 1"
                v-model="item.value"
                class="w100"
              ></el-input>
              <el-input
                size="small"
                v-if="item.structType === 'n'"
                :disabled="!isEdit || item.isRead === 1 || isGrey(item)"
                v-model="item.value"
                :step="item.dot"
                class="w100"
              >
                <template slot="append" v-if="item.unitId">{{item.unitName}}</template>
              </el-input>
              <el-select
                v-if="item.structType === 'm' || item.structType === 's'"
                size="small"
                :disabled="!isEdit || item.isRead === 1"
                class="w100"
                collapse-tags
                :multiple="item.structType === 'm'"
                v-model="item.value"
                clearable
              >
                <el-option
                  v-for="option in item.structItemList"
                  :key="option.id"
                  :label="option.value"
                  :value="option.value"
                ></el-option>
              </el-select>
              <el-date-picker
                v-if="item.structType ==='d'"
                size="small"
                v-model="item.value"
                format="yyyy-MM-dd"
                clearable
                value-format="yyyy-MM-dd"
                type="date"
                :disabled="!isEdit || item.isRead === 1"
                class="w100"
                placeholder="选择日期"
              ></el-date-picker>
              <el-date-picker
                v-if="item.structType ==='dt'"
                size="small"
                v-model="item.value"
                clearable
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                :disabled="!isEdit || item.isRead === 1"
                class="w100"
                placeholder="选择时间"
              ></el-date-picker>
              <el-input
                type="textarea"
                size="small"
                v-if="item.structType ==='ta'"
                :rows="2"
                placeholder="请输入内容"
                :disabled="!isEdit || item.isRead === 1"
                v-model="item.value"
              ></el-input>-->
            </el-form-item>
            <template v-else>
              <div v-if="item.structType === 'g'">
                <form-struct-group :copy-source="item.copySource" :form-struct-id="item.id" :is-project="isProject" :project-id="projectId" :household-id="householdId" :field-id="item.id" :title="item.structName" :groupData="item.childStructDatas" :isEdit="isEdit"></form-struct-group>
              </div>
              <div v-if="item.structType === 'b'">
                <form-struct-table :household-id="householdId" :project-id="projectId" :is-reference="isReference" :tableData="item.tableRowDataMap" :tableColumns="item.childStructDatas" :isEdit="isEdit" :structItem="item"></form-struct-table>
              </div>
              <div v-if="item.structType === 'k'">
                <form-struct-caliber @copy="handleCopyCaliber" @revert="handleRevertCaliberData" :project-id="projectId" :household-id="householdId" @re-name="handleRenameCaliber" @delete="handleDeleteCaliber" :caliberData="item" :isEdit="isEdit" @query-data="handleQueryData"></form-struct-caliber>
              </div>
            </template>
          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { deepCopyData } from '@/untils';
import FormStructGroup from './form-struct.group.vue';
import FormStructTable from './form-struct.table.vue';
import GovMeasureTool from './measure-tool';
export default {
  components: {
    // Contents,
    FormStructTable,
    GovMeasureTool,
    FormStructGroup
  },
  props: {
    isReference: {
      type: Boolean,
      default: true
    },
    version: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Array,
      required: true
    },
    financialData: {
      type: Array,
      required: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isProject: {
      type: Boolean,
      default: false
    },
    showFlag: {
      type: Boolean,
      default: false
    },
    formStructId: {
      type: String
    }
  },
  computed: {
    // 格式化后的数据
    formatData() {
      if (this.formData && Array.isArray(this.formData)) {
        for (let item of this.formData) {
          // 多选类型;
          // if (item.structType === 'm') {
          //   const isArray = item.value instanceof Array;
          //   if (!isArray) {
          //     let value = item.value;
          //     item.value =
          //       value && typeof value === 'string' ? value.split(',') : [];
          //   }
          //   if (item.value.length <= 0) {
          //     item.value = '';
          //   }
          //   continue;
          // }
          // 分组
          if (item.structType === 'g') {
            // if (item.value === null) {
            //   item.value = 'g';
            // }
            if (item.childStructDatas.length > 0) {
              let flag = item.childStructDatas.find(item => item.value);
              if (flag) {
                if (flag.value) {
                  item.value = 'g';
                } else {
                  item.value = '';
                }
              } else {
                item.value = '';
              }
              // item.childStructDatas.forEach(newItem => {
              //   if (newItem.value) {
              //     item.value = 'g';
              //   } else {
              //     item.value = '';
              //   }
              // });
            }
          }
          // 测距仪类型
          if (item.structType === 'di') {
            if (isUndef(item.oldValue)) {
              item.oldValue = item.computationProcess || 'NOT';
              item.value = item.computationProcess;
            }
            continue;
          }
          if (item.structType === 'k') {
            const { structCaliberDtoList } = item;
            item.caliberDataList.forEach(data => {
              data.caliberTypeList = deepCopyData(structCaliberDtoList);
              if (data.caliberTypeId !== '') {
                for (let caliberType of structCaliberDtoList) {
                  if (data.caliberTypeId === caliberType.caliberTypeId) {
                    data.caliberProList = caliberType.caliberItems;
                    break;
                  }
                }
              }
              if (
                data.caliberItemId !== '' &&
                Array.isArray(data.caliberProList)
              ) {
                for (let pro of data.caliberProList) {
                  if (data.caliberItemId === pro.id) {
                    data.caliberSpecificationList =
                      pro.caliberSpecificationDtos;
                    break;
                  }
                }
              }
            });
          }
        }
      }
      return this.formData;
    }
  },
  data() {
    return {
      ruleForm: {},
      projectId: '',
      householdId: '',
      templateId: '',
      formTemplateItemId: ''
    };
  },
  methods: {
    getSpan(item) {
      const blockType = ['b', 'g', 'k', 'ta'];
      const isBlock = blockType.indexOf(item.structType) > -1;
      if (isBlock) {
        return 24;
      }
      return 12;
    },
    // 是不显示 日志功能
    showLogIcon(item) {
      const blockType = ['b', 'g', 'k'];
      const isBlock = blockType.indexOf(item.structType) > -1;
      return !isBlock;
    }
  },
  created() { }
};
</script>
<style>
.el-input.is-disabled /deep/ .el-input__inner {
  color: #333333;
  font-size: 16px;
}
.el-textarea.is-disabled .el-textarea__inner {
  color: #333333;
  font-size: 16px;
}
.w100 {
  width: 100% !important;
}
.form-field-wrap {
  position: relative;
  margin: 5px 0;
}
.data-log-icon-wrap {
  position: absolute;
  right: 10px;
  top: -4px;
}
.el-form-item__content {
  line-height: normal !important;
}
.el-form-item__label {
  line-height: 24px !important;
}
.form-field-wrap .el-form-item {
  margin-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/FormStruct.vue